import { Button } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnumPriceComponentReference } from '../../../../../api/Argentia/enums'

interface PcTypeInstancesHeaderActionsProps {
  onSaveClick: () => void
  onEditDummyPriceClick: () => void
  onBackButtonClick: () => void
  referenceType: EnumPriceComponentReference
}

export const PcTypeInstancesHeaderActions: React.FC<PcTypeInstancesHeaderActionsProps> = ({
  onSaveClick,
  onEditDummyPriceClick,
  onBackButtonClick,
  referenceType
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'priceComponentTypeInstances'])

  return (
    <>
      <Button variant="text" color="primary" size="small" onClick={onBackButtonClick}>
        {t('priceComponentTypeInstances:header.actions.back')}
      </Button>
      {(referenceType === EnumPriceComponentReference.Lead ||
        referenceType === EnumPriceComponentReference.Oferta) && (
        <Button variant="text" color="primary" size="small" onClick={onEditDummyPriceClick}>
          {t('priceComponentTypeInstances:header.actions.editDummyPrice')}
        </Button>
      )}
      <Button variant="contained" color="primary" size="small" onClick={onSaveClick}>
        {t('priceComponentTypeInstances:header.actions.save')}
      </Button>
    </>
  )
}
